export async function getUserLocalisationByIP() {
  const apiKey = import.meta.env.VITE_EXTREME_IP_LOOKUP;

  try {
    const res = await fetch(`https://extreme-ip-lookup.com/json/?key=${apiKey}`);
    const response = await res.json();

    return response;
    // Handle the response here
  } catch (error) {
    console.error('Error fetching the user location:', error);
    return '';
  }
}
